import React from "react";
import { Trans, useTranslation } from "react-i18next";
import Hyperlink from "@ingka/hyperlink";
import { config } from "../../config";
import { getCredentialUrl } from "../../utils";
import styled from "styled-components";

const NoEventsHeader = styled.p`
  font-size: var(--font-size-800);
  font-weight: bold;
  color: var(--colour-text-dark);
`;

const Wrapper = styled.div`
  ${({ theme }) => `${theme.breakpoints.lg} {
    margin-bottom: var(--space-400);
  }`}

  h1,h2 {
    margin-bottom: var(--space-100);

    ${({ theme }) => `${theme.breakpoints.lg} {
      margin-bottom: var(--space-150);
    }`}
  }

  p:not(${NoEventsHeader}) {
    &:not(:last-of-type) {
      margin-bottom: var(--space-200);
      ${({ theme }) => `${theme.breakpoints.lg} {
        max-width: 550px;
        margin-bottom: var(--space-300);
      }`}
    }
  }
`;

const NoEvents = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <NoEventsHeader>{t("event.noEvents")}</NoEventsHeader>
      <p>{t("event.noEventsDesc")}</p>
      <h2>{t("event.stayUptoDate")}</h2>
      <p>
        <Trans
          i18nKey="event.joinIKEAFamily"
          components={{
            JoinLink: (
              <Hyperlink
                url={getCredentialUrl(config.joinIkeaFamily)}
                text={t("event.joinIKEAFamilyLink")}
              />
            ),
          }}
        />
      </p>
    </Wrapper>
  );
};

export default React.memo(NoEvents);
